import { faCircle, faFileTimes, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const PUBLIC_ACCESS_OPTION = 'public_access';
export const NO_OVERRIDE_OPTION = 'no_override';

export const REVOKE_OPTION = {
  value: PUBLIC_ACCESS_OPTION,
  label: LabelWithIcon({ text: 'Revoke Secure Access', icon: faFileTimes, color: '#1e3150', size: 'lg' })
};

export const accessLevelColors = {
  high: '#DF6978',
  medium: '#F7B500',
  low: '#4A4A4A',
  public_access: '#19a86f',
  warning: '#F87431',
};

export const publicAccessDisplay = LabelWithIcon({ text: 'Public', color: accessLevelColors.public_access });

export const accessLevelsWithPrefix = (icon = faCircle, prefix = '') => {
  return [
    {
      value: 'high',
      label: LabelWithIcon({ text: `${prefix}High`, icon: icon, color: accessLevelColors.high })
    },
    {
      value: 'medium',
      label: LabelWithIcon({ text: `${prefix}Medium`, icon: icon, color: accessLevelColors.medium })
    },
    {
      value: 'low',
      label: LabelWithIcon({ text: `${prefix}Low`, icon: icon, color: accessLevelColors.low })
    },
    {
      value: 'ca_high',
      label: LabelWithIcon({
        text: `${prefix}High`,
        icon: faTriangleExclamation,
        color: accessLevelColors.warning,
        tooltipText: pendingCA
      })
    },
    {
      value: 'ca_medium',
      label: LabelWithIcon({
        text: `${prefix}Medium`,
        icon: faTriangleExclamation,
        color: accessLevelColors.warning,
        tooltipText: pendingCA
      })
    },
    {
      value: 'ca_low',
      label: LabelWithIcon({
        text: `${prefix}Low`,
        icon: faTriangleExclamation,
        color: accessLevelColors.warning,
        tooltipText: pendingCA
      })
    }
  ];
};

const pendingCA = 'This lead will have this access level applied once the CA is signed';

export const ACCESS_LEVELS = accessLevelsWithPrefix();
export const SELECTABLE_ACCESS_LEVELS = ACCESS_LEVELS.filter(level => !level.value.startsWith('ca_'));

export function LabelWithIcon({ text, icon = faCircle, color = 'black', size = 'sm', tooltipText = '' }) {
  return (
    tooltipText !== '' ?
      <OverlayTrigger
        overlay={<Tooltip id={`label-with-icon-tooltip`}>{tooltipText}</Tooltip>}
        placement="top"
      >
        <span>
          <FontAwesomeIcon className="mr-3" color={color} fixedWidth icon={icon} size={size}/>{text}
        </span>
      </OverlayTrigger>
      :
      <span>
        <FontAwesomeIcon className="mr-3" color={color} fixedWidth icon={icon} size={size}/>{text}
      </span>
  );
}

LabelWithIcon.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.object,
  size: PropTypes.string,
  text: PropTypes.string,
  tooltipText: PropTypes.string
};
